<template>
  <div class="billing-month-picker">
    <vue-monthly-picker
      ref="picker"
      :value="momentValue"
      :min="min"
      :max="max"
      :monthLabels="monthLabels"
      :clearOption="false"
      dateFormat="MM/YYYY"
      placeHolder="mm/aaaa"
      inputClass="form-control m-input"
      selectedBackgroundColor="#36a3f7"
      @input="emitChangeEvent"
    />
  </div>
</template>

<script>
import moment from 'moment';
import VueMonthlyPicker from 'vue-monthly-picker';

/**
 * Campo de competência (mês/ano) da fatura.
 *
 * Usa o seletor de mês/ano em calendário, sem digitação livre, evitando anos
 * inválidos (ex.: 09/26 no lugar de 09/2026). O valor exposto via v-model
 * continua no formato mm/yyyy, que é o formato esperado pela API.
 */
const MODEL_FORMAT = 'MM/YYYY';
const YEARS_BACK = 5;
const YEARS_AHEAD = 1;

export default {
  name: 'InputBillingMonth',
  components: { VueMonthlyPicker },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      monthLabels: [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ],
    };
  },
  computed: {
    momentValue() {
      const date = moment(this.value, MODEL_FORMAT, true);
      return date.isValid() ? date : null;
    },
    min() {
      return moment().subtract(YEARS_BACK, 'years').startOf('year');
    },
    max() {
      return moment().add(YEARS_AHEAD, 'years').endOf('year');
    },
  },
  methods: {
    emitChangeEvent(date) {
      const isInRange =
        date && date.isValid() && !date.isBefore(this.min) && !date.isAfter(this.max);

      this.$emit('input', isInRange ? date.format(MODEL_FORMAT) : '');
    },
    focus() {
      this.$refs.picker.openMenu();
    },
  },
};
</script>

<style>
.billing-month-picker {
  width: 100%;
}

.billing-month-picker .month-year-label {
  outline: none;
}

.billing-month-picker .month-year-display {
  cursor: pointer;
}

.billing-month-picker .month-year-display.placeholder {
  color: #a7abc3;
}

.billing-month-picker .date-popover {
  border: 0;
  border-radius: 4px;
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.2);
  padding: 8px;
}

.billing-month-picker .date-popover .flexbox {
  border: 0;
}

.billing-month-picker .date-popover .flexbox > div {
  font-weight: 500;
}

.billing-month-picker .date-popover .prev,
.billing-month-picker .date-popover .next {
  border-radius: 4px;
}

.billing-month-picker .date-popover .prev:hover:not(.deactive),
.billing-month-picker .date-popover .next:hover:not(.deactive) {
  background-color: #f4f5f8;
}

.billing-month-picker .monthItem .item {
  border: 0;
  border-radius: 4px;
  padding: 8px 0;
  transition: background-color 0.2s ease;
}

.billing-month-picker .monthItem .item.active:hover {
  background-color: #f4f5f8;
}

.billing-month-picker .monthItem .item.selected {
  color: #fff;
  font-weight: 500;
}
</style>
